module.exports = __webpack_public_path__ + "img/symbol_1.e0900f0b.png";